import { twMerge } from 'tailwind-merge';

import { tNamespace } from '../services/translation';
import { Button } from './buttons/button';

const t = tNamespace('components.limit-block');

export type LimitBlockProps = {
  label: string;
  current: number;
  total: number;
  isUnlimited: boolean;
  onUpgradeClick: () => void;
  className?: string;
};

export function LimitBlock(props: LimitBlockProps) {
  const { label, current, total, onUpgradeClick, className, isUnlimited } = props;

  // Calculate percentage, handle edge case where total is 0
  let totalLabel = `${total}`;
  let percentage = total > 0 ? Math.max(0, Math.round((current / total) * 100)) : 0;

  // unlimited is a special case
  if (isUnlimited) {
    percentage = 1;
    totalLabel = t('unlimited');
  }

  return (
    <div
      className={twMerge(
        'flex items-center justify-between gap-8 rounded-lg border border-branding-gray bg-white p-6',
        className
      )}
    >
      {/* Header row: label and upgrade button */}
      <div className="flex w-full flex-col items-start justify-between gap-2">
        <div className="flex w-full justify-between">
          <p className="font-body-2-m text-dark-gray">{label}</p>
          <p className="font-body-2-m text-gray">
            {current} / {totalLabel}
          </p>
        </div>
        {/* Progress bar */}
        <div className="h-2 w-full rounded-full bg-branding-gray-200">
          <div
            className="h-full rounded-full bg-branding-dark-gray transition-all duration-300"
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
        {/* Percentage */}
        <p className="font-body-3-r text-gray">{t('percentUsed', { percentage })}</p>
      </div>
      {isUnlimited ? null : (
        <Button variant="outline" size="sm" onClick={onUpgradeClick}>
          {t('upgrade')}
        </Button>
      )}
    </div>
  );
}
